const HeroCarouselSlideOne = () => {
  const handleNavigation = (e, url) => {
    e.stopPropagation();
    window.location.href = url;
  };

  return (
    <div className='carousel__slide-box'>
      <div className='carousel__texts-box'>
        <h1 className='carousel__slide-main--text'>Africa Ships Here</h1>
        <p className='carousel__slide-sub--text'>
          The fastest, most reliable way to ship parcels, cargo, and freight
          across Nigeria and the world from your doorstep.
        </p>
        <div className='hero__section-hero--section__ctas'>
          <button
            className='hero__carousel-cta'
            onClick={e => handleNavigation(e, 'https://ship.topship.africa')}
          >
            Start Shipping
          </button>

          <button
            onClick={e => handleNavigation(e, '/#request-quote')}
            className='hero__carousel-cta hero__carousel-cta--two'
          >
            Get Qoute
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroCarouselSlideOne;
